import api from './api';
import { 
  User, 
  CreateUserRequest, 
  UpdateUserRequest, 
  SearchUsersRequest, 
  PagedUsersResponse, 
  ResetPasswordRequest,
  ChangePasswordRequest,
  UpdateProfileRequest 
} from '../types/userManagement';

// API per la gestione utenti (solo admin)
export const userManagementApi = {
  // Cerca utenti con paginazione
  searchUsers: async (searchRequest: SearchUsersRequest): Promise<PagedUsersResponse> => {
    try {
      const response = await api.post<PagedUsersResponse>('/usermanagement/search', searchRequest);
      return response.data;
    } catch (error: any) {
      console.error('Errore nella ricerca utenti:', error);
      throw new Error(error.response?.data?.message || 'Errore nella ricerca utenti');
    }
  },

  // Ottieni utente per ID
  getUserById: async (userId: string): Promise<User> => {
    try {
      const response = await api.get<User>(`/usermanagement/${userId}`);
      return response.data;
    } catch (error: any) {
      console.error('Errore nel recupero utente:', error);
      throw new Error(error.response?.data?.message || 'Errore nel recupero utente');
    }
  },

  // Crea nuovo utente
  createUser: async (createRequest: CreateUserRequest): Promise<User> => {
    try {
      const response = await api.post<User>('/usermanagement', createRequest);
      return response.data;
    } catch (error: any) {
      console.error('Errore nella creazione utente:', error);
      throw new Error(error.response?.data?.message || 'Errore nella creazione utente');
    }
  },

  // Aggiorna utente
  updateUser: async (userId: string, updateRequest: UpdateUserRequest): Promise<User> => {
    try {
      const response = await api.put<User>(`/usermanagement/${userId}`, updateRequest);
      return response.data;
    } catch (error: any) {
      console.error('Errore nell\'aggiornamento utente:', error);
      throw new Error(error.response?.data?.message || 'Errore nell\'aggiornamento utente');
    }
  },

  // Elimina utente
  deleteUser: async (userId: string): Promise<void> => {
    try {
      await api.delete(`/usermanagement/${userId}`);
    } catch (error: any) {
      console.error('Errore nell\'eliminazione utente:', error);
      throw new Error(error.response?.data?.message || 'Errore nell\'eliminazione utente');
    }
  },

  // Reset password
  resetPassword: async (resetRequest: ResetPasswordRequest): Promise<void> => {
    try {
      await api.post('/usermanagement/reset-password', resetRequest);
    } catch (error: any) {
      console.error('Errore nel reset password:', error);
      throw new Error(error.response?.data?.message || 'Errore nel reset password');
    }
  },

  // Attiva/disattiva utente
  toggleUserStatus: async (userId: string, isActive: boolean): Promise<void> => {
    try {
      await api.patch(`/usermanagement/${userId}/toggle-status`, isActive);
    } catch (error: any) {
      console.error('Errore nel cambio stato utente:', error);
      throw new Error(error.response?.data?.message || 'Errore nel cambio stato utente');
    }
  },

  // Sblocca utente
  unlockUser: async (userId: string): Promise<void> => {
    try {
      await api.post(`/usermanagement/${userId}/unlock`);
    } catch (error: any) {
      console.error('Errore nello sblocco utente:', error);
      throw new Error(error.response?.data?.message || 'Errore nello sblocco utente');
    }
  },

  // Ottieni ruoli disponibili
  getAvailableRoles: async (): Promise<string[]> => {
    try {
      const response = await api.get<string[]>('/usermanagement/roles');
      return response.data;
    } catch (error: any) {
      console.error('Errore nel recupero ruoli:', error);
      throw new Error(error.response?.data?.message || 'Errore nel recupero ruoli');
    }
  }
};

// API per il profilo utente personale
export const userProfileApi = {
  // Cambia password
  changePassword: async (changeRequest: ChangePasswordRequest): Promise<void> => {
    try {
      await api.post('/userprofile/change-password', changeRequest);
    } catch (error: any) {
      console.error('Errore nel cambio password:', error);
      throw new Error(error.response?.data?.message || 'Errore nel cambio password');
    }
  },

  // Aggiorna profilo
  updateProfile: async (updateRequest: UpdateProfileRequest): Promise<User> => {
    try {
      const response = await api.put<User>('/userprofile/profile', updateRequest);
      return response.data;
    } catch (error: any) {
      console.error('Errore nell\'aggiornamento profilo:', error);
      throw new Error(error.response?.data?.message || 'Errore nell\'aggiornamento profilo');
    }
  }
};